/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    BINARY: 2,
    OCTAL: 8,
    DECIMAL: 10,
    HEXADECIMAL: 16
}
